/**
 * API Configuration
 * Update these endpoints to match your backend API
 */

import sourcemedium from "@/pages/Analytics/source_medium";
import { upgrade_Subscriptions } from "@/services/subscriptionsApi";

const ENV = "development"; // change to "production" when deploying

const BASE_URLS: Record<string, string> = {
  // domain: "http://192.168.1.209:3000/",
  // development: "http://192.168.1.209:3000/api",
  // production: "https://pactivatebackend.packtivate.io/api",

  domain: "https://packtivate-prod-s3-bucket.s3.ap-south-1.amazonaws.com/",
  development: "https://pactivatebackend.packtivate.io/api",
  production: "https://pactivatebackend.packtivate.io/api",
};

export const API_CONFIG = {
  domain: BASE_URLS["domain"],
  baseUrl: BASE_URLS[ENV],
  endpoints: {
    auth: {
      login: "/auth/login-pass",
      signup: "/auth/register",
      forgotpassword: "/auth/forgot-password",
      resetpassword: "/auth/reset-password",
      refresh: "/auth/refresh",
      logout: "/auth/logout",
      verifyMfa: "/auth/verify-mfa",
      generateMfa: "/auth/mfa/generate-setup",
      enableMfa: "/auth/mfa/enable",
      disableMfa: "/auth/mfa/disable",
    },
    dashboard: {
      locations_chart: "/dashboard/overview-locations-chart/:user_id",
      scan_overview: "/dashboard/scan-overview/:user_id",
      user_engagement: "/dashboard/user-engagement/:user_id",
      state_wise_pie_chart: "/dashboard/state-wise-pie-chart/:user_id",
      qr_overview_chart: "/dashboard/qr-overview-chart/:user_id",
      ///new api
      overview: "/charts/dashboard/overview-stats/:user_id",
      website_performance: "/charts/dashboard/performance-stats/:user_id",
      scan_device: "/charts/dashboard/device-stats/:user_id",
      sessions_region: "/charts/dashboard/geographical-stats/:user_id",
      topwebsites: "/charts/dashboard/top-websites/:user_id",
    },
    Qr: {
      qrlist: "/qr/list/user/:userId",
      qrdetails: "/qr/details/:id",
      qrcreate: "/qr/create",
      qrupdate: "/qr/update/:id",
      qrdelete: "/qr/delete/:id",
      qrdownload: "/qr/download-qr/:id",
    },
    media: {
      get: "/upload/list/:user_id",
      upload: "/upload/file",
      delete: "/upload/delete/:id",
      template_upload: "/upload/template-file",
    },
    project: {
      create: "/projects/create",
      get: "/projects/user/:userId",
      getslug: "/projects/:slug",
      details: "/projects/details/:id",
      update: "/projects/update/:id",
      delete: "/projects/delete/:id",
      statusupdate: "/projects/toggle-status/:id",
      getprojectqr: "/qr/projects-without-qr/:userId",
    },
    pages: {
      list: "/pages/list/project/:projectId",
      get: "/pages/details/:pageId",
      create: "/pages/create",
      update: "/pages/update/:pageId",
      delete: "/pages/delete/:pageId",
    },

    template: {
      preview: "/templates/preview/:id",
      getcategory: "/categories/list",
      list: "/pages/list/project/:projectId",
      get: "/templates/list",
      create: "/pages/create",
      update: "/pages/update/:pageId",
      delete: "/pages/delete/:pageId",
    },

    forms: {
      submit: "/page-responses/save-response",
    },
    transactions: {
      list: "/billing/user-history/:user_id",
      details: "/billing/details/:billing_id",
    },
    subscriptions: {
      all: "/subscriptions/all/:userId",
      create_subscription: "/subscriptions/create",
      upgrade_subscription: "/subscriptions/upgrade",
    },
    user: {
      profileDetails: "/user/details/:id",
      updateProfile: "/user/update-profile/:id",
      changePassword: "/auth/change-password",
      sendVerifyEmail: "/auth/send-verification-email",
    },
    products: {
      userProducts: "/products/user-products/:user_id",
      productDetails: "/products/details/:id",
      deleteProduct: "/products/delete/:id",
      createProduct: "/products/create",
      updateProduct: "/products/update/:id",
      bulkProducts: "/products/bulk-create",
    },
    pageResponses: {
      allFormsResponse: "/page-responses/all-pages/:userId",
      pageResponses: "/page-responses/page/:id",
      exportResponseCsv: "/page-responses/page/export/:id",
    },
    analytics: {
      insightsTable: "/charts/analytics/ga-project-analytics/details/:user_id",
      sourcemedium:
        "/charts/analytics/ga-project-analytics/source-medium-details/:user_id",
      qrCardStats: "/analytics/qr-scans-client/stats/:user_id",
      timewiseScanCountsChart:
        "/analytics/qr-scans-client/timewise-qr-counts/:user_id",
      deiveScansPieChart:
        "/analytics/qr-scans-client/device-scans-pie/:user_id",
      locationScansDemographic:
        "/analytics/demographic-client/location-scans/:user_id",
      deviceWisePieChartDeviceTab:
        "/analytics/device/device-pie-chart/:user_id",
      browserPieChartDeviceTab: "/analytics/device/browser-pie-chart/:user_id",
      deviceAndBrowserScansTable:
        "/analytics/device/device-browser-table/:user_id",
      scanDetailsCard: "/charts/analytics/scan-analytics/details/:user_id",
      barGraphCard:
        "/charts/analytics/scan-analytics/total-scans-bar-chart/:user_id",
      scanLineChart:
        "/charts/analytics/scan-analytics/trend-over-time/:user_id",
    },
    log: {
      logs: "/logs/client-user-activity-logs/:id",
    },
    notifications: {
      settoken: "/notifications/save-notification-token",
    },
  },
};

/**
 * Get full API URL
 */
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.baseUrl}${endpoint}`;
};

/**
 * Replace URL parameters
 */
export const replaceUrlParams = (
  url: string,
  params: Record<string, string>,
): string => {
  let result = url;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
};
